<span class="action" *ngIf="!!action && !!origAction" [ngSwitch]="action.type"
  [ngClass]="{'highlight' : highlight, 'inline' : inline, 'right' : right, 'text-black' : textBlack || right,  'fh' : fhStyle, 'aoe' : hasAOE}">
  <span class="action-area" *ngSwitchCase="ActionType.area" [ngClass]="{'small' : action.small}">
    <ghs-action-hex [action]="action" [value]="'' + action.value" [size]="hexSize" [index]="actionIndex"
      [cardId]="cardId" [character]="character"></ghs-action-hex>
  </span>

  <span class="action-condition" *ngSwitchCase="ActionType.condition" [ngClass]="{'small' : action.small}">
    <span class="condition" ghs-pointer-input (singleClick)="toggleHighlight($event)"
      [clickBehind]="!isInteractiveApplicableAction" [ghs-tooltip]="'monster.toggleAction'" [delay]="1"
      [disabled]="!isInteractiveApplicableAction"
      [ngClass]="{'action-interactive' : isInteractiveApplicableAction, 'action-interactive-highlight': highlightAction()}">
      <span class="condition-value">
        <span [ghs-label]="('game.condition.' + getConditionName(values[0]))"
          [ghs-label-args]="(values.length > 1 ? [values[1]] : [])" [style]="style"></span>
      </span>
      <span class="condition-image">
        <img class="icon" *ngIf="getConditionName(values[0]) != 'invalid'"
          [src]="'./assets/images' + (fhStyle ? '/fh' : '') + '/condition/' + getConditionName(values[0]) + '.svg'" />
        <img class="icon warning" *ngIf="getConditionName(values[0]) == 'invalid'" src="./assets/images/warning.svg" />
        <span *ngIf="values.length > 1" class="value">{{values[1]}}</span>
      </span>

      <ghs-action-enhancements
        *ngIf="!!origAction.enhancementTypes && origAction.enhancementTypes.length && !!character && cardId"
        [action]="origAction" [index]="actionIndex" [character]="character" [cardId]="cardId"></ghs-action-enhancements>
    </span>
    <div class="subactions" *ngIf="subActions.length > 0">
      <ng-container *ngFor="let subAction of subActions | slice:(hasAOE ? 1 : 0); let index = index;">
        <span *ngIf="fhStyle && index > 0">,</span>
        <ghs-action [ngClass]="'subaction-' + subAction.type" [action]="subAction" [monster]="monster"
          [objective]="objective" [inline]="inline" [right]="right" [textBlack]="textBlack" [hexSize]="hexSize"
          [statsCalculation]="statsCalculation" [interactiveAbilities]="interactiveAbilities"
          [interactiveActions]="interactiveActions" (interactiveActionsChange)="onInteractiveActionsChange($event)"
          [index]="(actionIndex ? actionIndex + '-' : '') + getOrigIndex(subAction)" [monsterType]="monsterType"
          [character]="character" [cardId]="cardId" [style]="style">
        </ghs-action>
      </ng-container>
    </div>
  </span>

  <span class="action-element"
    [ngClass]="{'small' : action.small,'action-element-consume' : action.valueType == ActionValueType.minus}"
    *ngSwitchCase="[ActionType.element, ActionType.elementHalf].includes(action.type) ? action.type : ''">
    <ng-container *ngIf="action.type == ActionType.element">
      <span class="elements" ghs-pointer-input (singleClick)="toggleHighlight($event)"
        [clickBehind]="!isInteractiveApplicableAction" [ghs-tooltip]="'monster.toggleAction'" [delay]="1"
        [disabled]="!isInteractiveApplicableAction"
        [ngClass]="{'action-interactive' : isInteractiveApplicableAction, 'action-interactive-highlight': highlightAction()}">
        <span class="element" *ngFor="let element of values; let i = index;"
          [ngClass]="{'consume' : action.valueType == ActionValueType.minus,  'wild' : element == 'wild'}">
          <img [src]="'./assets/images' + (fhStyle ? '/fh' : '') + '/element/' + element + '.svg'" />
        </span>
        <span class="minus" *ngIf="action.valueType == ActionValueType.minus && subActions.length > 0">:</span>
      </span>
    </ng-container>

    <span *ngIf="action.type == ActionType.elementHalf && values.length == 2" class="elements elements-half">
      <span class="element-half-container"
        [ngClass]="{'consume' : action.valueType == ActionValueType.minus, 'action-interactive' : isInteractiveApplicableAction, 'action-interactive-highlight': highlightAction()}"
        ghs-pointer-input (singleClick)="toggleHighlight($event)" [clickBehind]="!isInteractiveApplicableAction"
        [ghs-tooltip]="'monster.toggleAction'" [delay]="1" [disabled]="!isInteractiveApplicableAction">
        <span class="element-half">
          <img [src]="'./assets/images' + (fhStyle ? '/fh' : '') + '/element/' + values[0] + '.svg'" />
        </span>
        <span class="element-half">
          <img [src]="'./assets/images' + (fhStyle ? '/fh' : '') + '/element/' + values[1] + '.svg'" />
        </span>
      </span>
      <span class="minus" *ngIf="action.valueType == ActionValueType.minus">:</span>
    </span>
    <div class="element-subactions" *ngIf="subActions.length > 0">
      <ng-container *ngFor="let subAction of subActions; let index = index;">
        <span *ngIf="fhStyle && index > 0">,</span>
        <ghs-action class="element-subaction" [ngClass]="'subaction-' + subAction.type" [action]="subAction"
          [monster]="monster" [objective]="objective" [relative]="relative || forceRelative" [inline]="inline"
          [right]="right" [textBlack]="textBlack" [hexSize]="hexSize" [interactiveAbilities]="interactiveAbilities"
          [interactiveActions]="interactiveActions" (interactiveActionsChange)="onInteractiveActionsChange($event)"
          [statsCalculation]="statsCalculation"
          [index]="(actionIndex ? actionIndex + '-' : '') +  getOrigIndex(subAction)" [monsterType]="monsterType"
          [character]="character" [cardId]="cardId" [style]="style">
        </ghs-action>
      </ng-container>
    </div>
  </span>

  <ng-container *ngSwitchCase="ActionType.monsterType">
    <span class="action-monster-type" [ngClass]="{'small' : action.small}"
      *ngIf="relative || hasEntities('' + action.value)">
      <span class="monster-type small" [ngClass]="'monster-type-' + action.value"><span
          [ghs-label]="'monster.' + action.value" [style]="style"></span>:</span>
      <div class="monster-type-subactions" *ngIf="subActions.length > 0">
        <ng-container *ngFor="let subAction of subActions; let index = index;">
          <span *ngIf="fhStyle && index > 0">,</span>
          <ghs-action [ngClass]="'subaction-' + subAction.type" [action]="subAction" [monster]="monster"
            [objective]="objective" [relative]="relative" [inline]="inline" [right]="right" [textBlack]="textBlack"
            [hexSize]="hexSize" [interactiveAbilities]="interactiveAbilities" [interactiveActions]="interactiveActions"
            (interactiveActionsChange)="onInteractiveActionsChange($event)" [statsCalculation]="statsCalculation"
            [index]="(actionIndex ? actionIndex + '-' : '') + getOrigIndex(subAction)"
            [monsterType]="getMonsterType('' + action.value)" [style]="style">
          </ghs-action>
        </ng-container>
      </div>
    </span>
  </ng-container>

  <ng-container *ngSwitchCase="ActionType.round">
    <span class="action-round" [ngClass]="{'small' : action.small}" *ngIf="action.value == round">
      <div class="round-subactions" *ngIf="subActions.length > 0">
        <ng-container *ngFor="let subAction of subActions; let index = index;">
          <ghs-action [ngClass]="'subaction-' + subAction.type" [action]="subAction" [monster]="monster"
          [objective]="objective" [inline]="inline" [right]="right" [textBlack]="textBlack" [hexSize]="hexSize"
          [interactiveAbilities]="interactiveAbilities" [interactiveActions]="interactiveActions"
          (interactiveActionsChange)="onInteractiveActionsChange($event)" [relative]="relative || forceRelative"
          [statsCalculation]="statsCalculation"
          [index]="(actionIndex ? actionIndex + '-' : '') + getOrigIndex(subAction)" [monsterType]="monsterType"
          [character]="character" [cardId]="cardId" [style]="style">
        </ghs-action>
        </ng-container>
      </div>
    </span>
  </ng-container>

  <span class="action-specialTarget" *ngSwitchCase="ActionType.specialTarget">
    <div class="enhancements-container" #enhancementContainer>
      <span class="special-target-value" [ghs-label]="('game.specialTarget.' + values[0])"
        [ghs-label-args]="values.slice(1)" [relative]="relative || forceRelative" [style]="style"
        [ngClass]="{'text-white' : !textBlack && !right, 'small' : action.small}"></span>
      <span
        *ngIf="[ 'alliesRange:',  'alliesRangeAffect:','allyAffectRange:', 'enemiesRange:', 'enemiesRangeAffect:', 'enemyRange:'].indexOf(action.value + '') != -1"
        [ngClass]="{'small' : action.small}">
        <span>{{getRange()}}</span>
        <span *ngIf="getEliteRange() && getRange() != getEliteRange()">/</span>
        <span *ngIf="getEliteRange() && getRange() != getEliteRange()" class="elite">{{getEliteRange()}}</span>
      </span>

      <ng-container
        *ngFor="let i of [] | ghsRange:(character && cardId && origAction && origAction.enhancementTypes && origAction.enhancementTypes.length || 0)">
        <ghs-action-enhancements [action]="origAction" [index]="actionIndex" [character]="character" [cardId]="cardId"
          [slot]="i"></ghs-action-enhancements>
      </ng-container>
    </div>

    <div class="special-target-subactions" *ngIf="subActions.length > 0;">
      <ng-container *ngFor="let subAction of subActions; let index = index;">
        <span *ngIf="fhStyle && index > 0">,</span>
        <ghs-action [ngClass]="'subaction-' + subAction.type" [action]="subAction" [monster]="monster"
          [objective]="objective" [inline]="inline" [right]="right" [textBlack]="textBlack" [hexSize]="hexSize"
          [interactiveAbilities]="interactiveAbilities" [interactiveActions]="interactiveActions"
          (interactiveActionsChange)="onInteractiveActionsChange($event)" [relative]="relative || forceRelative"
          [statsCalculation]="statsCalculation"
          [index]="(actionIndex ? actionIndex + '-' : '') + getOrigIndex(subAction)" [monsterType]="monsterType"
          [character]="character" [cardId]="cardId" [style]="style">
        </ghs-action>
      </ng-container>
    </div>
  </span>

  <span class="action-custom" *ngSwitchCase="ActionType.custom">
    <div *ngIf="!action.enhancementTypes || action.enhancementTypes[0] != 'any'" class="enhancements-container"
      #enhancementContainer>
      <span class="custom-value" [ghs-label]="action.value + ''" [relative]="relative || forceRelative" [style]="style"
        [ngClass]="{'small' : action.small,'text-white' : !textBlack && !right}"></span>

      <ng-container
        *ngFor="let i of [] | ghsRange:(character && cardId && origAction && origAction.enhancementTypes && origAction.enhancementTypes.length || 0)">
        <ghs-action-enhancements [action]="origAction" [index]="actionIndex" [character]="character" [cardId]="cardId"
          [slot]="i"></ghs-action-enhancements>
      </ng-container>
    </div>

    <ng-container *ngIf="action.enhancementTypes && action.enhancementTypes[0] == 'any'">
      <span class="custom-value" [ghs-label]="action.value + ''" [relative]="relative || forceRelative" [style]="style"
        [ngClass]="{'small' : action.small,'text-white' : !textBlack && !right}"></span>

      <ghs-action-enhancements
        *ngIf="!!origAction.enhancementTypes && origAction.enhancementTypes.length && !!character && cardId"
        [action]="origAction" [index]="actionIndex" [character]="character" [cardId]="cardId"></ghs-action-enhancements>
    </ng-container>

    <div class="custom-subactions" *ngIf="subActions.length > 0">
      <ghs-action [ngClass]="'subaction-' + subAction.type"
        *ngFor="let subAction of subActions | slice:(hasAOE ? 1 : 0); let index = index;" [action]="subAction"
        [monster]="monster" [objective]="objective" [inline]="inline" [right]="right" [textBlack]="textBlack"
        [hexSize]="hexSize" [interactiveAbilities]="interactiveAbilities" [interactiveActions]="interactiveActions"
        (interactiveActionsChange)="onInteractiveActionsChange($event)" [relative]="relative || forceRelative"
        [statsCalculation]="statsCalculation" [index]="(actionIndex ? actionIndex + '-' : '') + getOrigIndex(subAction)"
        [monsterType]="monsterType" [character]="character" [cardId]="cardId" [style]="style">
      </ghs-action>
    </div>
  </span>

  <span class="action-custom" *ngSwitchCase="ActionType.nonCalc" ghs-pointer-input
    (singleClick)="toggleHighlight($event)" [clickBehind]="!isInteractiveApplicableAction"
    [ghs-tooltip]="'monster.toggleAction'" [delay]="1" [disabled]="!isInteractiveApplicableAction"
    [ngClass]="{'action-interactive' : isInteractiveApplicableAction, 'action-interactive-highlight': highlightAction()}">
    <span class="custom-value" [ghs-label]="action.value + ''" [relative]="relative || forceRelative" [style]="style"
      [ngClass]="{'small' : action.small,'text-white' : !textBlack && !right}"></span>
    <div class="custom-subactions" *ngIf="subActions.length > 0">
      <ghs-action [ngClass]="'subaction-' + subAction.type" *ngFor="let subAction of subActions; let index = index;"
        [action]="subAction" [monster]="monster" [objective]="objective" [inline]="inline" [right]="right"
        [textBlack]="textBlack" [hexSize]="hexSize" [interactiveAbilities]="interactiveAbilities"
        [interactiveActions]="interactiveActions" (interactiveActionsChange)="onInteractiveActionsChange($event)"
        [relative]="true" [statsCalculation]="statsCalculation"
        [index]="(actionIndex ? actionIndex + '-' : '') + getOrigIndex(subAction)" [monsterType]="monsterType"
        [character]="character" [cardId]="cardId" [style]="style">
      </ghs-action>
    </div>
  </span>

  <span class="action-custom" *ngSwitchCase="ActionType.sufferDamage" ghs-pointer-input
    (singleClick)="toggleHighlight($event)" [clickBehind]="!isInteractiveApplicableAction"
    [ghs-tooltip]="'monster.toggleAction'" [delay]="1" [disabled]="!isInteractiveApplicableAction"
    [ngClass]="{'action-interactive' : isInteractiveApplicableAction, 'action-interactive-highlight': highlightAction()}">
    <span class="custom-value" [ghs-label]="'game.sufferDamage'" [relative]="relative || forceRelative" [style]="style"
      [ngClass]="{'small' : action.small,'text-white' : !textBlack && !right}"
      [ghs-label-args]="[ monster ? '%data.monster.' + monster.name + '%' : '', action.value]"></span>
    <div class="custom-subactions" *ngIf="subActions.length > 0">
      <ghs-action [ngClass]="'subaction-' + subAction.type" *ngFor="let subAction of subActions; let index = index"
        [action]="subAction" [monster]="monster" [objective]="objective" [inline]="inline" [right]="right"
        [textBlack]="textBlack" [hexSize]="hexSize" [interactiveAbilities]="interactiveAbilities"
        [interactiveActions]="interactiveActions" (interactiveActionsChange)="onInteractiveActionsChange($event)"
        [relative]="relative || forceRelative" [statsCalculation]="statsCalculation"
        [index]="(actionIndex ? actionIndex + '-' : '') + getOrigIndex(subAction)" [monsterType]="monsterType"
        [character]="character" [cardId]="cardId" [style]="style">
      </ghs-action>
    </div>
  </span>

  <span class="action-custom" *ngSwitchCase="ActionType.switchType">
    <span class="custom-value" [ghs-label]="action.value + ''" [relative]="relative || forceRelative" [style]="style"
      [ngClass]="{'small' : action.small,'text-white' : !textBlack && !right}"></span>
    <div class="custom-subactions" *ngIf="subActions.length > 0">
      <ghs-action [ngClass]="'subaction-' + subAction.type" *ngFor="let subAction of subActions; let index = index;"
        [action]="subAction" [monster]="monster" [objective]="objective" [inline]="inline" [right]="right"
        [textBlack]="textBlack" [hexSize]="hexSize" [interactiveAbilities]="interactiveAbilities"
        [interactiveActions]="interactiveActions" (interactiveActionsChange)="onInteractiveActionsChange($event)"
        [relative]="relative || forceRelative" [statsCalculation]="statsCalculation"
        [index]="(actionIndex ? actionIndex + '-' : '') + getOrigIndex(subAction)" [monsterType]="monsterType"
        [character]="character" [cardId]="cardId" [style]="style">
      </ghs-action>
    </div>
  </span>

  <span class="action-hint" *ngSwitchCase="ActionType.hint" [ghs-label]="action.value + ''"></span>

  <span class="action-grant" *ngSwitchCase="ActionType.grant">
    <span class="grant-value" [ghs-label]="action.value + ''" [relative]="relative || forceRelative" [style]="style"
      [ngClass]="{'small' : action.small,'text-white' : !textBlack && !right}"></span>
    <div class="grant-subactions" *ngIf="subActions.length > 0">
      <ghs-action [ngClass]="'subaction-' + subAction.type" *ngFor="let subAction of subActions; let index = index"
        [action]="subAction" [monster]="monster" [objective]="objective" [inline]="inline" [right]="right"
        [textBlack]="textBlack" [hexSize]="hexSize" [interactiveAbilities]="interactiveAbilities"
        [interactiveActions]="interactiveActions" (interactiveActionsChange)="onInteractiveActionsChange($event)"
        [relative]="true" [statsCalculation]="false" [index]="(actionIndex ? actionIndex + '-' : '') + index"
        [monsterType]="monsterType" [character]="character" [cardId]="cardId" [style]="style">
      </ghs-action>
    </div>
  </span>

  <span class="action-summon" *ngSwitchCase="ActionType.summon" [ngClass]="{'small' : action.small}">
    <ghs-action-summon [action]="action" [right]="right" [textBlack]="textBlack" [monster]="monster"
      [objective]="objective" [interactiveAbilities]="interactiveAbilities" [interactiveActions]="interactiveActions"
      (interactiveActionsChange)="onInteractiveActionsChange($event)" [index]="actionIndex" [character]="character"
      [cardId]="cardId" [monsterType]="monsterType" [character]="character" [cardId]="cardId"
      [style]="style"></ghs-action-summon>
    <ng-container *ngIf="subActions.length > 0">
      <ghs-action [ngClass]="'subaction-' + subActions[index+(hasAOE ? 1 : 0)].type"
        *ngFor="let index of [] | ghsRange:subActions.length" [action]="subActions[index+(hasAOE ? 1 : 0)]"
        [monster]="monster" [objective]="objective" [inline]="inline" [right]="right" [textBlack]="textBlack"
        [hexSize]="hexSize" [interactiveAbilities]="interactiveAbilities" [interactiveActions]="interactiveActions"
        (interactiveActionsChange)="onInteractiveActionsChange($event)" [relative]="relative || forceRelative"
        [statsCalculation]="statsCalculation"
        [index]="(actionIndex ? actionIndex + '-' : '') + getOrigIndex(subActions[index+(hasAOE ? 1 : 0)])"
        [monsterType]="monsterType" [character]="character" [cardId]="cardId" [style]="style">
      </ghs-action>
    </ng-container>
  </span>

  <span class="action-summon" *ngSwitchCase="ActionType.spawn" [ngClass]="{'small' : action.small}">
    <ghs-action-summon [action]="action" [right]="right" [textBlack]="textBlack" [monster]="monster"
      [objective]="objective" [spawn]="true" [interactiveAbilities]="interactiveAbilities"
      [interactiveActions]="interactiveActions" (interactiveActionsChange)="onInteractiveActionsChange($event)"
      [index]="actionIndex" [character]="character" [cardId]="cardId" [monsterType]="monsterType"
      [character]="character" [cardId]="cardId" [style]="style"></ghs-action-summon>
    <ng-container *ngIf="subActions.length > 0">
      <ghs-action [ngClass]="'subaction-' + subAction.type" *ngFor="let subAction of subActions; let index = index"
        [action]="subAction" [monster]="monster" [objective]="objective" [inline]="inline" [right]="right"
        [textBlack]="textBlack" [hexSize]="hexSize" [interactiveAbilities]="interactiveAbilities"
        [interactiveActions]="interactiveActions" (interactiveActionsChange)="onInteractiveActionsChange($event)"
        [relative]="relative || forceRelative" [statsCalculation]="statsCalculation"
        [index]="(actionIndex ? actionIndex + '-' : '') + getOrigIndex(subAction)" [monsterType]="monsterType"
        [character]="character" [cardId]="cardId" [style]="style">
      </ghs-action>
    </ng-container>
  </span>

  <span class="action-trigger" *ngSwitchCase="ActionType.trigger">
    <span class="custom-value" [ghs-label]="action.value + ''" [relative]="relative || forceRelative" [style]="style"
      [ngClass]="{'small' : action.small,'text-white' : !textBlack && !right}"></span>
    <ng-container *ngIf="subActions.length > 0;">
      <ghs-action [ngClass]="'subaction-' + subAction.type" *ngFor="let subAction of subActions; let index = index"
        [action]="subAction" [monster]="monster" [objective]="objective" [inline]="inline" [right]="right"
        [textBlack]="textBlack" [hexSize]="hexSize" [interactiveAbilities]="interactiveAbilities"
        [interactiveActions]="interactiveActions" (interactiveActionsChange)="onInteractiveActionsChange($event)"
        [relative]="relative || forceRelative" [statsCalculation]="statsCalculation"
        [index]="(actionIndex ? actionIndex + '-' : '') + getOrigIndex(subAction)" [monsterType]="monsterType"
        [character]="character" [cardId]="cardId" [style]="style">
      </ghs-action>
    </ng-container>
  </span>

  <span class="action-default" *ngSwitchCase="ActionType.concatenation">
    <span class="action-concatenation" [ngClass]="{'small' : action.small, 'card-concat': cardConcat}">
      <ng-container
        *ngFor="let subAction of (subActions | slice:0:(values.length > 1  ? +(values[1]) : subActions.length)); let index = index;">
        <ghs-action [ngClass]="'subaction-' + subAction.type" [action]="subAction" [monster]="monster"
          [objective]="objective" [inline]="inline" [right]="right" [textBlack]="textBlack" [hexSize]="hexSize"
          [interactiveAbilities]="interactiveAbilities" [interactiveActions]="interactiveActions"
          (interactiveActionsChange)="onInteractiveActionsChange($event)" [relative]="relative || forceRelative"
          [statsCalculation]="statsCalculation"
          [index]="(actionIndex ? actionIndex + '-' : '') + getOrigIndex(subAction)" [monsterType]="monsterType"
          [character]="character" [cardId]="cardId" [style]="style">
        </ghs-action>
        <span
          *ngIf="!inline && (values.length > 1 && +(values[1]) > 0 && index < +(values[1]) - 1 || values.length < 2 && index < subActions.length -1) && subAction.type != ActionType.concatenationSpacer"
          class="action-concatenation-item">
          <span *ngIf="values.length > 0">
            <span *ngIf="!fhStyle" [ghs-label]="values[0]" [relative]="relative || forceRelative"
              [style]="style"></span>
            <span *ngIf="fhStyle">,</span>
          </span>
        </span>
      </ng-container>
    </span>
    <div class="subactions" *ngIf="values.length > 1 && subActions.length > +values[1]">
      <ng-container
        *ngFor="let subAction of (subActions | slice:+values[1] + (hasAOE ? 1 : 0):subActions.length); let index = index;">
        <span *ngIf="fhStyle && index > 0">,</span>
        <ghs-action [ngClass]="'subaction-' + subAction.type" [action]="subAction" [monster]="monster"
          [objective]="objective" [inline]="inline" [right]="right" [textBlack]="textBlack" [hexSize]="hexSize"
          [interactiveAbilities]="interactiveAbilities" [interactiveActions]="interactiveActions"
          (interactiveActionsChange)="onInteractiveActionsChange($event)" [relative]="relative || forceRelative"
          [statsCalculation]="statsCalculation"
          [index]="(actionIndex ? actionIndex + '-' : '') + getOrigIndex(subAction)" [monsterType]="monsterType"
          [character]="character" [cardId]="cardId" [style]="style">
        </ghs-action>
      </ng-container>
    </div>
  </span>

  <span class="action-default" *ngSwitchCase="ActionType.concatenationSpacer">
    <span class="action-concatenation-spacer">
      <span *ngFor="let i of []|ghsRange:(EntityValueFunction(action.value) || 1)"
        class="action-concatenation-spacer-item" [ngClass]="{'small' : action.small}">
        &nbsp;
      </span>
    </span>
  </span>

  <span class="action-default" *ngSwitchCase="ActionType.grid">
    <span class="action-grid" [style.--ghs-grid-columns]="action.value || 2" [ngClass]="{'small' : action.small}"
      *ngIf="subActions.length > 0">
      <ng-container *ngFor="let subAction of subActions; let index = index;">
        <ghs-action [ngClass]="'subaction-' + subAction.type" [action]="subAction" [monster]="monster"
          [objective]="objective" [inline]="inline" [right]="right" [textBlack]="textBlack" [hexSize]="hexSize"
          [interactiveAbilities]="interactiveAbilities" [interactiveActions]="interactiveActions"
          (interactiveActionsChange)="onInteractiveActionsChange($event)" [relative]="relative || forceRelative"
          [statsCalculation]="statsCalculation"
          [index]="(actionIndex ? actionIndex + '-' : '') + getOrigIndex(subAction)" [monsterType]="monsterType"
          [character]="character" [cardId]="cardId" [style]="style">
        </ghs-action>
      </ng-container>
    </span>
  </span>

  <span class="action-box-container" *ngSwitchCase="ActionType.box"
    [ngClass]="{'small' : action.small, 'empty': subActions.length == 0, 'first': actionIndex == '0'}">
    <span *ngIf="action.value" class="action-box-label" [ghs-label]="'' + action.value"
      [relative]="relative || forceRelative" [style]="style"></span>
    <span class="action-box">
      <ng-container *ngFor="let subAction of subActions; let index = index;">
        <ghs-action [ngClass]="'subaction-' + subAction.type" [action]="subAction" [monster]="monster"
          [objective]="objective" [inline]="inline" [right]="right" [textBlack]="textBlack" [hexSize]="hexSize"
          [interactiveAbilities]="interactiveAbilities" [interactiveActions]="interactiveActions"
          (interactiveActionsChange)="onInteractiveActionsChange($event)" [relative]="relative || forceRelative"
          [statsCalculation]="statsCalculation"
          [index]="(actionIndex ? actionIndex + '-' : '') + getOrigIndex(subAction)" [monsterType]="monsterType"
          [character]="character" [cardId]="cardId" [style]="style">
        </ghs-action>
      </ng-container>
    </span>
  </span>

  <span class="action-box-fh-subactions-container" *ngSwitchCase="ActionType.boxFhSubActions"
    [ngClass]="{'small' : action.small}">
    <span *ngIf="action.value" class="action-box-label" [ghs-label]="'' + action.value"
      [relative]="relative || forceRelative" [style]="style"></span>
    <span class="action-box">
      <ng-container *ngFor="let subAction of subActions; let index = index;">
        <ghs-action [ngClass]="'subaction-' + subAction.type" [action]="subAction" [monster]="monster"
          [objective]="objective" [inline]="inline" [right]="right" [textBlack]="textBlack" [hexSize]="hexSize"
          [interactiveAbilities]="interactiveAbilities" [interactiveActions]="interactiveActions"
          (interactiveActionsChange)="onInteractiveActionsChange($event)" [relative]="relative || forceRelative"
          [statsCalculation]="statsCalculation"
          [index]="(actionIndex ? actionIndex + '-' : '') + getOrigIndex(subAction)" [monsterType]="monsterType"
          [character]="character" [cardId]="cardId" [style]="style">
        </ghs-action>
      </ng-container>
    </span>
  </span>

  <span class="action-box-container-forced" *ngSwitchCase="ActionType.forceBox" [ngClass]="{'small' : action.small}">
    <span *ngIf="action.value" class="action-box-label" [ghs-label]="'' + action.value"
      [relative]="relative || forceRelative" [style]="style"></span>
    <span *ngIf="!action.value" class="action-box-label"><span class="value">!</span></span>
    <span class="action-box">
      <ng-container *ngFor="let subAction of subActions; let index = index;">
        <ghs-action [ngClass]="'subaction-' + subAction.type" [action]="subAction" [monster]="monster"
          [objective]="objective" [inline]="inline" [right]="right" [textBlack]="textBlack" [hexSize]="hexSize"
          [interactiveAbilities]="interactiveAbilities" [interactiveActions]="interactiveActions"
          (interactiveActionsChange)="onInteractiveActionsChange($event)" [relative]="relative || forceRelative"
          [statsCalculation]="statsCalculation"
          [index]="(actionIndex ? actionIndex + '-' : '') + getOrigIndex(subAction)" [monsterType]="monsterType"
          [character]="character" [cardId]="cardId" [style]="style">
        </ghs-action>
      </ng-container>
    </span>
  </span>

  <ng-container *ngSwitchCase="ActionType.card">
    <span class="action-card" [ngClass]="{'small' : action.small}">
      <div class="card-value" [ngClass]="values[0]">
        <img class="ghs-svg" [src]="'./assets/images/action/card/'+ values[0] + '.svg'" />
        <img *ngIf="values[0] != 'slot' && values[0] != 'slotStart' && values[0] != 'slotXp'" class="overlay"
          [src]="'./assets/images/action/card/overlay/' + values[0] + '.svg'" />
        <span *ngIf="values[0] == 'slot' || values[0] == 'slotStart' || values[0] == 'slotXp'" class="overlay"
          [style.mask-image]="'url(\'/assets/images/action/card/overlay/' + values[0] +'.svg\')'"
          [style.-webkit-mask-image]="'url(\'/assets/images/action/card/overlay/' + values[0] +'.svg\')'">
        </span>
        <span class="value" *ngIf="values.length > 1">{{values[1]}}</span>
      </div>
    </span>
  </ng-container>

  <span class="action-default action-special" *ngSwitchCase="ActionType.special" [ngClass]="{'small' : action.small}">
    <span class="special-type"><span [ghs-label]="'game.action.' + action.type" [style]="style"></span>
      {{action.value}}:</span>
    <ghs-actions class="special-subactions" [actions]="specialActions" [monster]="monster" [objective]="objective"
      [inline]="inline" [right]="right" [textBlack]="textBlack" [hexSize]="hexSize"
      [interactiveAbilities]="interactiveAbilities" [interactiveActions]="interactiveActions"
      (interactiveActionsChange)="onInteractiveActionsChange($event)" [relative]="relative || forceRelative"
      [statsCalculation]="statsCalculation" [index]="actionIndex" [character]="character" [cardId]="cardId"
      [style]="style">
    </ghs-actions>
  </span>

  <span class="action-default" [ngClass]="'action-' + action.type" *ngSwitchDefault>
    <span class="main-action"
      [ngClass]="{'small' : action.small, 'action-interactive' : isInteractiveApplicableAction, 'action-interactive-highlight': highlightAction()}"
      ghs-pointer-input (singleClick)="toggleHighlight($event)" [clickBehind]="!isInteractiveApplicableAction"
      [ghs-tooltip]="'monster.toggleAction'" [delay]="1" [disabled]="!isInteractiveApplicableAction">
      <ng-container *ngIf=" action.valueType != ActionValueType.add && action.valueType != ActionValueType.subtract">
        <span class="type"><span [ghs-label]="'game.action.' + action.type" [style]="style"></span></span>

        <span class="action-icon">
          <img *ngIf="action.type != ActionType.move || !flying"
            [src]="'./assets/images' + (fhStyle ? '/fh' : '') + '/action/' + action.type + '.svg'" class="icon"
            [ngClass]="{'ghs-svg' : isGhsSvg(action.type)}" />
          <img *ngIf="action.type == ActionType.move && flying"
            [src]="'./assets/images' + (fhStyle ? '/fh' : '') + '/action/fly.svg'" class="icon"
            [ngClass]="{'ghs-svg' : isGhsSvg(action.type)}" />
        </span>
        <span class="value">
          <span *ngIf="!relative && !forceRelative">
            <ng-container *ngIf="hasEntities(MonsterType.normal) || !monster">
              <span [value-calc]="normalValue" [level]="level"></span>
            </ng-container>
            <ng-container
              *ngIf="hasEntities(MonsterType.normal) && hasEntities(MonsterType.elite) && normalValue != eliteValue">
              <span>/</span>
            </ng-container>
            <ng-container
              *ngIf="hasEntities(MonsterType.elite) && (normalValue != eliteValue || !hasEntities(MonsterType.normal))">
              <span [ngClass]="{'elite' : hasEntities(MonsterType.normal)}" [value-calc]="eliteValue"
                [level]="level"></span>
            </ng-container>
          </span>
          <span *ngIf="relative || forceRelative">
            <ng-container *ngIf="hasEntities(MonsterType.normal) || !monster || forceRelative">
              <span [ghs-label]="normalValue+ ''" [relative]="relative || forceRelative" [style]="style"></span>
            </ng-container>
            <ng-container
              *ngIf="hasEntities(MonsterType.normal) && hasEntities(MonsterType.elite) && normalValue != eliteValue">
              <span>/</span>
            </ng-container>
            <ng-container
              *ngIf="hasEntities(MonsterType.elite) && (normalValue != eliteValue || !hasEntities(MonsterType.normal))">
              <span [ngClass]="{'elite' : hasEntities(MonsterType.normal)}" [ghs-label]="eliteValue + ''"
                [relative]="relative || forceRelative" [style]="style"></span>
            </ng-container>
            <span *ngIf="!fhStyle">&nbsp;</span>
          </span>
        </span>
      </ng-container>

      <ng-container *ngIf="action.valueType == ActionValueType.add || action.valueType == ActionValueType.subtract">
        <span class="value">
          {{action.valueType == ActionValueType.add ? '+' : '-'}}
          <span *ngIf="!relative && !forceRelative">
            <span [value-calc]="normalValue" [level]="level"></span>
            <span *ngIf="eliteValue && normalValue != eliteValue">/</span>
            <span *ngIf="eliteValue && normalValue != eliteValue" class="elite" [value-calc]="eliteValue"
              [level]="level"></span>
          </span>
          <span *ngIf="relative || forceRelative" [ghs-label]="normalValue + ''" [relative]="relative || forceRelative"
            [style]="style">
            <span *ngIf="normalValue != eliteValue">/<span class="elite" [ghs-label]="eliteValue + ''"
                [relative]="relative || forceRelative" [style]="style"></span>
            </span>
          </span>
          <span *ngIf="!fhStyle">&nbsp;</span>
        </span>

        <span class="type" *ngIf="action.type == ActionType.target && EntityValueFunction(action.value) > 1">
          <span [ghs-label]="'game.action.targets'" [style]="style"></span></span>

        <span *ngIf="action.type != ActionType.target || EntityValueFunction(action.value) < 2" class="type">
          <span [ghs-label]="'game.action.' + action.type" [style]="style"></span>
        </span>

        <img *ngIf="action.type != ActionType.move || !flying"
          [src]="'./assets/images' + (fhStyle ? '/fh' : '') + '/action/' + action.type + '.svg'" class="icon"
          [ngClass]="{'ghs-svg' : isGhsSvg(action.type)}" />
        <img *ngIf="action.type == ActionType.move && flying"
          [src]="'./assets/images' + (fhStyle ? '/fh' : '') + '/action/fly.svg'" class="icon"
          [ngClass]="{'ghs-svg' : isGhsSvg(action.type)}" />
      </ng-container>

      <ghs-action-enhancements
        *ngIf="!!origAction.enhancementTypes && origAction.enhancementTypes.length && !!character && cardId"
        [action]="origAction" [index]="actionIndex" [character]="character" [cardId]="cardId"></ghs-action-enhancements>
    </span>

    <div class="subactions"
      *ngIf="((statsCalculation && additionalSubActions.length > 0 ? additionalSubActions : subActions)  | slice:(hasAOE ? 1 : 0)).length >  0">
      <ng-container
        *ngFor="let subAction of (statsCalculation && additionalSubActions.length > 0 ? additionalSubActions : subActions) | slice:(hasAOE ? 1 : 0); let index = index;">
        <span *ngIf="fhStyle && index > 0">,</span>
        <ghs-action [ngClass]="'subaction-' + subAction.type" [action]="subAction" [monster]="monster"
          [objective]="objective" [inline]="inline" [right]="right" [textBlack]="textBlack" [hexSize]="hexSize"
          [interactiveAbilities]="interactiveAbilities" [interactiveActions]="interactiveActions"
          (interactiveActionsChange)="onInteractiveActionsChange($event)" [relative]="relative || forceRelative"
          [statsCalculation]="statsCalculation"
          [index]="(actionIndex ? actionIndex + '-' : '') + getOrigIndex(subAction)" [monsterType]="monsterType"
          [character]="character" [cardId]="cardId" [style]="style">
        </ghs-action>
      </ng-container>
    </div>
  </span>

  <div class="aoe-value" *ngIf="hasAOE" [ngClass]="{'small' : action.small}">
    <ghs-action [ngClass]="'subaction-area'"
      [action]="(statsCalculation && additionalSubActions.length > 0 ? additionalSubActions : subActions)[0]"
      [monster]="monster" [objective]="objective" [inline]="inline" [right]="right" [textBlack]="textBlack"
      [hexSize]="hexSize" [interactiveAbilities]="interactiveAbilities" [interactiveActions]="interactiveActions"
      (interactiveActionsChange)="onInteractiveActionsChange($event)" [relative]="relative || forceRelative"
      [statsCalculation]="statsCalculation"
      [index]="(actionIndex ? actionIndex + '-' : '') + getOrigIndex((statsCalculation && additionalSubActions.length > 0 ? additionalSubActions : subActions)[0])"
      [monsterType]="monsterType" [character]="character" [cardId]="cardId" [style]="style">
    </ghs-action>
  </div>

  <ng-container *ngIf="elementActions.length > 0 && fhStyle">
    <div class="element-actions">
      <ghs-action *ngFor="let subAction of elementActions" [ngClass]="'subaction-' + subAction.type"
        [action]="subAction" [monster]="monster" [objective]="objective" [inline]="inline" [right]="right"
        [textBlack]="textBlack" [hexSize]="hexSize" [interactiveAbilities]="interactiveAbilities"
        [interactiveActions]="interactiveActions" (interactiveActionsChange)="onInteractiveActionsChange($event)"
        [relative]="relative || forceRelative" [statsCalculation]="statsCalculation"
        [index]="(actionIndex ? actionIndex + '-' : '') + getOrigIndex(subAction)" [monsterType]="monsterType"
        [character]="character" [cardId]="cardId" [style]="style">
      </ghs-action>
    </div>
  </ng-container>
</span>